import apiEndpoints from '../../constants/ApiEndpoints';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import callApi from '../../utils/call_apis';
import React from "react";
import Snackbar from '../generals/Snackbar';
import TextField from '@mui/material/TextField';
import { setSnackbar } from '../../stores/SnackbarSlice';
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import Link from '@mui/material/Link';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import sellerValidationSchema from '../../validations/SellerFormValidation';


function SellersGroupListingForm() {

  const initialValues = {
    'search_in_field': '',
    'search_value_in_field': '',
    'order_by': 'updated_at',
    'order_type': 'desc',
    'page_no': 1,
  }
  const [reqPayload, setReqPayload] = React.useState(initialValues);
  const [paginationData, setPaginationData] = React.useState(0);
  // console.log('---paginationData:', paginationData)
  const [bids, setBids] = React.useState([]);
  const [listingFields, setListingFields] = React.useState([]);
  const [exportFileLink, setExportFileLink] = React.useState('');
  const dispatch = useDispatch();

  React.useEffect(() => {
    getEmpBidListing(initialValues)
  }, []);

  const [searchBy, setSearchBy] = React.useState('name');

  const handleSearchByChange = (event) => {
    setSearchBy(event.target.value);
  };

  const [orderBy, setOrderBy] = React.useState('updated_at');

  const handleOrderByChange = (event) => {
    setOrderBy(event.target.value);
  };

  const [orderType, setOrderType] = React.useState('desc');

  const handleOrderTypeChange = (event) => {
    setOrderType(event.target.value);
  };

  const handleFilterOnSubmit = values => {
    // console.log('---handleFilterOnSubmit---')
    // console.log('---handleFilterOnSubmit---values:', values)
    if (values['search_value_in_field']) {
      values[`${searchBy}`] = values['search_value_in_field'];
    }
    if (orderType == 'desc') {
      values['order_by'] = orderBy;
      values['order_type'] = orderType;
    } else {
      values['order_by'] = orderBy;
      values['order_type'] = '';
    }

    getEmpBidListing(values);
  }

  const formik = useFormik({
    initialValues,
    onSubmit: handleFilterOnSubmit,
    // validate,
    validationSchema: sellerValidationSchema.sellerBidListingSchema,
    validateOnChange: false
  })

  // console.log('---formik--values:', formik.values);
  // console.log('---formik--errors:', formik.errors);

  const resetFormFilter = () => {
    formik.setValues(initialValues)
    getEmpBidListing(initialValues)
  }

  const successResponse = (response) => {
    // console.log('---successResponse--response:', response);
    dispatch(setSnackbar({
      status: 'success',
      message: response.data.message
    }))
    setBids(response.data.data.dataset)
    setListingFields(response.data.data.listing_fields)
    setReqPayload(response.data.data.req_payload)
    setPaginationData(response.data.data.pagination)
  }

  const errorResponse = (error) => {
    formik.setErrors({ ...error.response.data.errors })
    // console.log('---errorResponse--formik--errors---221:', formik.errors);
  }

  const getEmpBidListing = async (data = {}) => {
    try {
      const response = await callApi.requestGET(`/sellers-bids/emp/sellers-groups-listing`, data, true)
      // console.log('---getEmpBidListing---response:', response);
      successResponse(response)
    }
    catch (error) {
      // console.log('---getEmpBidListing---error:', error);
      errorResponse(error)
    }
  }

  const fetchExportFile = async (data = {}) => {
    try {
      const response = await callApi.requestGET(`/sellers-bids/emp/sellers-groups-mob-number-export`, data, true)
      // console.log('---getEmpBidListing---response:', response);
      // successResponse(response)
      setExportFileLink(`${apiEndpoints.apiHost}${response.data.export_file_link}`)
    }
    catch (error) {
      // console.log('---getEmpBidListing---error:', error);
      errorResponse(error)
    }
  }
  


  return (
    <div>
      <Box component="form" className="" onSubmit={formik.handleSubmit}>
        <div className='tw-grid mob:tw-grid-cols-2 desktop:tw-grid-cols-8 tw-gap-5'>

          <div className='tw-col-span-1'>
            <FormControl fullWidth>
              <InputLabel id="searchByLabel">Search By</InputLabel>
              <Select
                labelId="searchByLabel"
                id="searchById"
                name="search_in_field"
                value={searchBy}
                label="Search By"
                onChange={handleSearchByChange}
                error={formik.errors.search_in_field ? true : false}
              >
                {/* <MenuItem value={10}>Product Title</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem> */}
                {listingFields.map((listingField) => (
                  <MenuItem key={listingField.key} value={listingField.key}>{listingField.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className='tw-col-span-1'>
            <TextField id="outlined-basic" label="Search" name="search_value_in_field" onChange={formik.handleChange} value={formik.values.search_value_in_field} error={formik.errors.search_value_in_field ? true : false} helperText={formik.errors.search_value_in_field} variant="outlined" />
          </div>

          {/* <div className='tw-col-span-1'>
            <FormControl fullWidth>
              <InputLabel id="orderByLabel">Order By</InputLabel>
              <Select
                labelId="orderByLabel"
                id="orderById"
                name="order_by"
                value={orderBy}
                label="Order By"
                onChange={handleOrderByChange}
                error={formik.errors.order_by ? true : false}
              >
                {listingFields.map((listingField) => (
                  <MenuItem key={listingField.key} value={listingField.key}>{listingField.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div> */}

          {/* <div className='tw-col-span-1'>
            <FormControl fullWidth>
              <InputLabel id="orderTypeLabel">Order Type</InputLabel>
              <Select
                labelId="orderTypeLabel"
                id="orderTypeId"
                name="order_type"
                value={orderType}
                label="Order Type"
                onChange={handleOrderTypeChange}
                error={formik.errors.order_type ? true : false}
              >
                <MenuItem value={0}>Ascending</MenuItem>
                <MenuItem value={'desc'}>Descending</MenuItem>
              </Select>
            </FormControl>
          </div> */}

          <div className='tw-col-span-1'>
            <TextField id="outlined-basic" label="Page No" type="number" name="page_no" onChange={formik.handleChange} value={formik.values.page_no} error={formik.errors.page_no ? true : false} helperText={formik.errors.page_no || `Total ${paginationData?.total_pages} Pages`} variant="outlined" />
          </div>

          <div className='tw-col-span-1'>
            <div className='tw-mt-3'>
              <Link className='' component="a" href="/emp/create-sellers-group" >Create Sellers Group</Link>
            </div>
          </div>

          <div className='tw-col-span-2 mob:tw-col-start-2 desktop:tw-col-start-7'>
            <Button className='tw-mx-5' variant="contained" onClick={resetFormFilter} >Reset</Button>
            <Button className='tw-mx-5' type="submit" variant="contained" >Filter</Button>
          </div>

        </div>
      </Box>

      {exportFileLink &&
        <div>
          Download Sellers Group Export, By click on <a className="tw-text-blue-500" href={exportFileLink}>link</a>
        </div>
      }

      <div className='tw-my-5 div-striped'>

        {/* <div  className="mob:tw-hidden desktop:tw-block tw-mt-5"> */}
        <div xs={12} sm={12} className='tw-w-f tw-grid desktop:tw-grid-cols-12 tw-gap-0 tw-border'>
          <span className='desktop:tw-col-span-3 tw-p-1'>Group Name</span>
          <span className='desktop:tw-col-span-1 tw-p-1'>Sellers in Group</span>
          <span className='desktop:tw-col-span-2 tw-p-1'>Download Mobile Numbers</span>
          <span className='desktop:tw-col-span-3 tw-p-1'>Created by</span>
          <span className='desktop:tw-col-span-2 tw-p-1'>Created at</span>
          <span className='desktop:tw-col-span-1 tw-p-1'>Action</span>
        </div>
        {/* </div> */}

        {bids.map((bid) => (
          // <li key={bid.id}>
          // <div className="tw-mt-2">
            <div key={bid.id} xs={12} sm={12} className='tw-w-f mob:tw-text-[12px] tw-grid mob:tw-grid-cols-6 desktop:tw-grid-cols-12 tw-gap-0 tw-border'>
              <span className='mob:tw-col-span-3 desktop:tw-col-span-3 tw-p-1 mob:tw-text-[14px]'>{bid.name}</span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-1 tw-p-1'><span className='mob:tw-block desktop:tw-hidden'>Sellers in Group: </span>{bid.mob_numbers_count}</span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-2 tw-p-1'><Link onClick={() => fetchExportFile({ 'group_id': bid.id })}>link</Link></span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-3 tw-p-1 tw-break-all'> {bid.created_by}</span>
              <span className='mob:tw-col-span-6 desktop:tw-col-span-2 tw-p-1 tw-flex'><span className='mob:tw-block desktop:tw-hidden'>Created at:&nbsp;</span>{bid.created_at}</span>
              <span className='mob:tw-col-span-2 desktop:tw-col-span-1 tw-p-1'><Link href={`/emp/create-sellers-group?seller_group_id=${bid.id}&form_action=update`} target='_blank'>Edit</Link></span>
            </div>
          // </div>
          // </li>
        ))}

      </div>

      <Snackbar />
    </div>
  );

}


export { SellersGroupListingForm };
